export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_11-1b7fb41d1785892ec1b6024cb6805420.jpg";